import axios from "axios";
import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import Select, {createFilter} from "react-select";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
    downloadTransactionLookupApi, getAccountManagerDatatableDetailsApi,
    getTerminalLocationByIDApi, getTransactionLookupApi, getUserViewListApi
} from "../Api";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import {useForm} from "react-hook-form";
import ConsoleHelper from "../ConsoleHelper";
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';

let count = 0;
function TransactionLookupDatatable(props) {
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const [terminalSelectData, setTerminalSelectData] = useState([]);
    const [selectedTerminal, setSelectedTerminal] = useState();
    const [userSelectData, setUserSelectData] = useState([]);
    const [selectedVisibleToUser, setSelectedVisibleToUser] = useState();
    const [selectedAccountOwner, setSelectedAccountOwner] = useState();
    const [data, setData] = useState([]);
    const [pan, setPan] = useState();
    const [traceID, setTraceID] = useState();
    const [traceDue, setTraceDue] = useState();
    const [bankTraceNo, setBankTraceNo] = useState();
    const [txnDateFrom, setTxnDateFrom] = useState(moment().startOf('day').add(-1, 'day').format('YYYY-MM-DD HH:mm:ss'));
    const [txnDateTo, setTxnDateTo] = useState(moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'));
    const [txnTimeTo, setTxnTimeTo] = useState();
    const [txnTimeFrom, setTxnTimeFrom] = useState();
    const [settDateFrom, setSettDateFrom] = useState();
    const [settDateTo, setSettDateTo] = useState();

    const [isTableVisible, setIsTableVisible] = useState(false);
    const [traceStatusOptions, setTraceStatusOptions] = useState();
    const [selectedTraceStatus, setTraceStatus] = useState();
    const [traceInitiatorOptions, setTraceInitiatorOptions] = useState();
    const [selectedTraceInitiator, setTraceInitiator] = useState();
    const [gatewayOptions, setGatewayOptions] = useState();
    const [selectedGateway, setGateway] = useState();
    const [dispensedStatusOptions, setDispensedStatusOptions] = useState();
    const [selectedDispensedStatus, setDispensedStatus] = useState();
    const [ISOOptions, setISOOptions] = useState();
    const [selectedISO, setISO] = useState();
    const [reconOptions, setReconOptions] = useState();
    const [selectedRecon, setRecon] = useState();
    const [selectedSortOrder, setSelectedSortOrder] = useState();
    const [userOptions, setUserOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState();
    const [perPage, setPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [resetUserForm, setResetUserForm] = useState(false);
    const [isDatatableLoaded, setDatatableLoaded] = useState(0);
    const history = useHistory();
    const location = useLocation();

    const {
        reset,
        formState: { errors }
    } = useForm();
    //  Internally, customStyles will deep merges your customStyles with the default styling.
    const tableStyles = {
        rows: {
            style: {
                minHeight: '30px',
                fontSize: '10px',// override the row height
            },
        },
        headCells: {
            style: {
                paddingLeft: '2px', // override the cell padding for data cells
                paddingRight: '2px',
                fontWeight: 'bold',
                textDecoration: 'underline'
            },
        },
        cells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
                fontSize: '10px',
                wordBreak: 'break-word',
            },
            draggingStyle: {},
        },
        dataTableExt: {
            style: {
                Width:'40px',
            },
        },
        rdt_TableHeadRow: {
            backgroundColor : 'red',
        }
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
            width: "9vw",
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };


    const datacolumns = [
        {
            name: 'Settlement Status',
            selector: row => row.traceStatus,
        },
        {
            name: 'TerminalID ',
            selector: row => row.terminalID,
            sortable: true,
        },
        {
            name: 'Terminal SeqNo ',
            selector: row => row.terminalSeqNo,
            sortable: true,
        },
        {
            name: 'Pan ',
            selector: row => row.pan,
            sortable: true,
        },
        {
            name: 'Transaction Type',
            selector: row => row.tranType,
            sortable: true,
        },
        {
            name: 'Amount ',
            selector: row => row.amountRequested,
            sortable: true,
        },
        {
            name: 'Dispensed ',
            selector: row => row.dispensed,
            sortable: true,
        },
        {
            name: 'surcharge ',
            selector: row => row.surcharge,
            sortable: true,
        },
        {
            name: 'Gateway Total ',
            selector: row => row.gatewayTotal,
            sortable: true,
        },
        {
            name: 'Interchange Paid',
            selector: row => row.interchangePaid,

            sortable: true,
        },
        {
            name: 'Switch Auth',
            selector: row => row.switchAuthText,
            sortable: true,
        }
    ];



    const onRowClicked = row => {
        history.push({
            pathname: "/accountManager/properties",
            search: `rta=${row.rta}&AccountID=${row.accountID}`,
        });
        ConsoleHelper(row)
        //setData(updatedData);
    };

    useEffect(() => {

        ConsoleHelper(" Loading object values... ")
        setTraceStatusOptions([
            { label: "All", value: "-1" },
            { label: "Daily", value: "Daily" },
            { label: "Weekly", value: "Weekly" },
            { label: "Monthly", value: "Monthly" },
            { label: "Threshold", value: "Threshold" },
        ]);

        setTraceInitiatorOptions([
            { label: "ATM", value: "ATM" }
        ]);

        setGatewayOptions([
            { label: "All", value: "-1" },
            { label: "Daily", value: "Daily" },
            { label: "Weekly", value: "Weekly" },
            { label: "Monthly", value: "Monthly" },
            { label: "Threshold", value: "Threshold" },
        ]);

        setDispensedStatusOptions([
            { label: "All", value: "-1" },
            { label: "No Consolidation", value: "No Consolidation" },
            { label: "Consolidate Across Funds Type", value: "Consolidate Across Funds Type" },
            { label: "Consolidate Across Terminals", value: "Consolidate Across Terminals" },
            { label: "Full Consolidation", value: "Full Consolidation" },
        ]);
        setISOOptions([
            { label: "All", value: "-1" },
            { label: "Daily", value: "Daily" },
            { label: "Weekly", value: "Weekly" },
            { label: "Monthly", value: "Monthly" },
            { label: "Threshold", value: "Threshold" },
        ]);
        setReconOptions([
            { label: "All", value: "-1" },
            { label: "Daily", value: "Daily" },
            { label: "Weekly", value: "Weekly" },
            { label: "Monthly", value: "Monthly" },
            { label: "Threshold", value: "Threshold" },
        ]);
        return () => {
            setData([]);
            setTerminalSelectData([]);
            setTraceStatusOptions([]);
            setTraceInitiatorOptions([]);
            setGatewayOptions([]);
            setDispensedStatusOptions([]);
            setISOOptions([]);
            setReconOptions([]);
            setUserOptions([]);

        };
    }, [location]);


    useEffect(() => {
        const terminalId = location?.search?.split("=")?.[1];
        const getLocationandTerminals = async () => {
            const selectedUserByDefault = (typeof selectedUser?.userId == "undefined") ? loggedUserStorage : selectedUser?.userId;
            var terminafeed = {selected: 'selected', label: 'Select All', value: '-1'};
            console.log(" Logged In user",selectedUserByDefault)
            const resultTerminal = await axios.get(`${getTerminalLocationByIDApi}?paramUserID=${selectedUserByDefault}&paramByType=TERMINAL&paramSearchCriteria=`);
            resultTerminal?.data.unshift(terminafeed);
            //console.log(" terminal list",resultTerminal?.data)
            setTerminalSelectData(resultTerminal?.data);
            if(resultTerminal?.data != undefined) {
                setSelectedAccountOwner({
                    label: "All",
                    value: "-1",
                });
            }else{
                setSelectedVisibleToUser([])
            }

            console.log(" GET USERS BY LIST")
            var feed = {userId: loggedUserStorage, label: loggedUserStorage, value: loggedUserStorage};
            const result = await axios.get(`${getUserViewListApi}?id=${loggedUserStorage}`);
            result?.data.unshift(feed);
            setUserOptions(result?.data);
            setSelectedUser({
                label: loggedUserStorage,
                value: loggedUserStorage,
            });

            setTraceStatus({
                label: "All",
                value: "-1",
            });
            setTraceInitiator({
                label: "ATM",
                value: "ATM",
            });
            setGateway({
                label: "All",
                value: "-1",
            });
            setDispensedStatus({
                label: "All",
                value: "-1",
            });
            setRecon({
                label: "All",
                value: "-1",
            });
            setISO({
                label: "All",
                value: "-1",
            });
        };

        getLocationandTerminals();
        return () => {
            setTraceStatus([]);
            setTraceInitiator([]);
            setGateway([]);
            setDispensedStatus([]);
            setRecon([]);
            setISO([]);
        };
    }, [resetUserForm]);

    const handletxnLookupStartDate = (start, end) => {
        setStartDate(start.format('YYYY-MM-DD  HH:mm:ss'))
        setTxnDateFrom(start.format('YYYY-MM-DD  HH:mm:ss'))
        console.log(start.format('YYYY-MM-DD  HH:mm:ss'),"Date for txn Lookup",txnDateFrom);
    };

    const handletxnLookupEndDate = (start, end) => {
        setEndDate(end.format('YYYY-MM-DD  HH:mm:ss'));
        setTxnDateTo(end.format('YYYY-MM-DD  HH:mm:ss'));
        console.log(end.format('YYYY-MM-DD  HH:mm:ss')," txn End date Lookup",txnDateTo);
    };
    const handleUserSelection = async (e) => {
        setSelectedUser(e);
        const selectedUserByDefault = (typeof e.value == "undefined") ? loggedUserStorage : e.value;
        const resultTerminal = await axios.get(`${getTerminalLocationByIDApi}?paramUserID=${selectedUserByDefault}&paramByType=TERMINAL&paramSearchCriteria=`);
        setTerminalSelectData(resultTerminal?.data);
        setTotalRecords(0)
    };

    const handleReset = async (e) => {
        setResetUserForm(true);
    };
    const handleEndDate = (start, end) => {
        console.log("====== ",start.format('YYYY-MM-DD  HH:mm:ss'))
        setTxnDateFrom(start.format('YYYY-MM-DD  HH:mm:ss'));
    };

    const generateExcel = async (e) => {
        console.log(" getting report ",selectedUser?.value)
        const selectedUserByDefault = (typeof selectedUser?.value == "undefined") ? loggedUserStorage : selectedUser?.value;
        axios({
            url: `${downloadTransactionLookupApi}?paramTerminalId=${(typeof selectedTerminal === 'undefined')? '-1': selectedTerminal?.value}
            &paramPan=${(typeof pan === 'undefined')? '-1': pan} &paramTraceID=${(typeof traceID === 'undefined')? '-1': traceID}
             &paramBankTraceNo=${(typeof bankTraceNo === 'undefined')? '-1': bankTraceNo} &paramTraceDue=${(typeof traceDue === 'undefined')? '-1': traceDue}
             &paramTraceInit=${(typeof selectedTraceInitiator === 'undefined')? '-1': selectedTraceInitiator?.value} 
             &paramTxnDateFrom=${(typeof txnDateFrom === 'undefined')? '-1': txnDateFrom}
             &paramTxnDateTo=${(typeof txnDateTo === 'undefined')? '-1': txnDateTo} 
             &paramTimeFrom=${(typeof txnTimeFrom === 'undefined')? '-1': txnTimeFrom}
             &paramTimeTo=${(typeof txnTimeto === 'undefined')? '-1': txnTimeTo} 
             &paramRecon=${(typeof selectedRecon === 'undefined')? '-1': selectedRecon?.value}
            &paramSettDateFrom=${(typeof settDateFrom === 'undefined')? '-1': settDateFrom}
            &paramSettDateTo=${(typeof settDateFrom === 'undefined')? '-1': settDateTo}
            &paramTraceStatus=${(typeof selectedTraceStatus === 'undefined')? '-1': selectedTraceStatus?.value}
            &paramGateway=${(typeof selectedGateway === 'undefined')? '-1': selectedGateway?.value}
            &paramDispStatus=${(typeof selectedDispensedStatus === 'undefined')? '-1': selectedDispensedStatus?.value}
            &paramISO=${(typeof selectedDispensedStatus === 'undefined')? '-1': selectedDispensedStatus?.value}
            &pSortOption=0&paramPageSize=40000&paramCurrentPage=1
            &paramUserID=${selectedUserByDefault}`, //your url
            method: "GET",
            responseType: "blob", // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TransactionLookupSummary.xls"); //or any other extension
            document.body.appendChild(link);
            link.click();
        });

    };

    const retrieveReport = async (e) => {
        ++count;
        console.log(" getting report ",count)
        setDatatableLoaded(count);
    };
   // useEffect(() => {
        const handleGetReport = async () => {
            try {
                //console.log(txnDateFrom,"<-From date to -> ",txnDateTo,startDate )
                console.log(" retrieving data =======",selectedTerminal?.value)
                const selectedUserByDefault = (typeof selectedUser?.value == "undefined") ? loggedUserStorage : selectedUser?.value;

                const result = await axios.get(`${getTransactionLookupApi}?paramTerminalId=${(typeof selectedTerminal === 'undefined')? '-1': selectedTerminal?.value}
            &paramPan=${(typeof pan === 'undefined')? '-1': pan} &paramTraceID=${(typeof traceID === 'undefined')? '-1': traceID}
             &paramBankTraceNo=${(typeof bankTraceNo === 'undefined')? '-1': bankTraceNo} &paramTraceDue=${(typeof traceDue === 'undefined')? '-1': traceDue}
             &paramTraceInit=${(typeof selectedTraceInitiator === 'undefined')? '-1': selectedTraceInitiator?.value} 
             &paramTxnDateFrom=${(typeof txnDateFrom === 'undefined')? '-1': txnDateFrom}
             &paramTxnDateTo=${(typeof txnDateTo === 'undefined')? '-1': txnDateTo} 
             &paramTimeFrom=${(typeof txnTimeFrom === 'undefined')? '-1': txnTimeFrom}
             &paramTimeTo=${(typeof txnTimeto === 'undefined')? '-1': txnTimeTo} 
             &paramRecon=${(typeof selectedRecon === 'undefined')? '-1': selectedRecon?.value}
            &paramSettDateFrom=${(typeof settDateFrom === 'undefined')? '-1': settDateFrom}
            &paramSettDateTo=${(typeof settDateFrom === 'undefined')? '-1': settDateTo}
            &paramTraceStatus=${(typeof selectedTraceStatus === 'undefined')? '-1': selectedTraceStatus?.value}
            &paramGateway=${(typeof selectedGateway === 'undefined')? '-1': selectedGateway?.value}
            &paramDispStatus=${(typeof selectedDispensedStatus === 'undefined')? '-1': selectedDispensedStatus?.value}
            &paramISO=${(typeof selectedDispensedStatus === 'undefined')? '-1': selectedDispensedStatus?.value}
            &pSortOption=0&paramPageSize=${perPage}&paramCurrentPage=${currentPage}
            &paramUserID=${selectedUserByDefault}`);

                const totalRecordsresult = await axios.get(`${getTransactionLookupApi}?paramTerminalId=${(typeof selectedTerminal === 'undefined')? '-1': selectedTerminal?.value}
            &paramPan=${(typeof pan === 'undefined')? '-1': pan} &paramTraceID=${(typeof traceID === 'undefined')? '-1': traceID}
             &paramBankTraceNo=${(typeof bankTraceNo === 'undefined')? '-1': bankTraceNo} &paramTraceDue=${(typeof traceDue === 'undefined')? '-1': traceDue}
             &paramTraceInit=${(typeof selectedTraceInitiator === 'undefined')? '-1': selectedTraceInitiator?.value} 
             &paramTxnDateFrom=${(typeof txnDateFrom === 'undefined')? '-1': txnDateFrom}
             &paramTxnDateTo=${(typeof txnDateTo === 'undefined')? '-1': txnDateTo} 
             &paramTimeFrom=${(typeof txnTimeFrom === 'undefined')? '-1': txnTimeFrom}
             &paramTimeTo=${(typeof txnTimeTo === 'undefined')? '-1': txnTimeTo} 
             &paramRecon=${(typeof selectedRecon === 'undefined')? '-1': selectedRecon?.value}
            &paramSettDateFrom=${(typeof settDateFrom === 'undefined')? '-1': settDateFrom}
            &paramSettDateTo=${(typeof settDateFrom === 'undefined')? '-1': settDateTo}
            &paramTraceStatus=${(typeof selectedTraceStatus === 'undefined')? '-1': selectedTraceStatus?.value}
            &paramGateway=${(typeof selectedGateway === 'undefined')? '-1': selectedGateway?.value}
            &paramDispStatus=${(typeof selectedDispensedStatus === 'undefined')? '-1': selectedDispensedStatus?.value}
            &paramISO=${(typeof selectedDispensedStatus === 'undefined')? '-1': selectedDispensedStatus?.value}
            &pSortOption=0&paramPageSize=10000000&paramCurrentPage=${currentPage}
            &paramUserID=${selectedUserByDefault}`);

                //console.log(" get result data ",result);
                setTotalRecords(totalRecordsresult?.data?.response?.length);
                setData(result?.data?.response);
                setIsTableVisible(true);


            } catch (error) {
                console.log(" ---- ",error)
                setIsTableVisible(false)
            }
        };
       // handleGetReport();

   // }, [currentPage,isDatatableLoaded]);

    return (
        <div>
            <div className="row mt-3">
                <div className="col col-md-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <label>User ID:</label>
                        <div>
                            <Select
                                options={userOptions}
                                value={selectedUser}
                                onChange={handleUserSelection}
                                filterOption={createFilter({ignoreAccents: false})}
                                captureMenuScroll={false}
                                classNamePrefix="custom-select"
                                components={{Option: CustomOption, MenuList: CustomMenuList}}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Terminals:</label>
                        <div>
                            <Select
                                options={terminalSelectData}
                                value={selectedTerminal}
                                onChange={(e) => setSelectedTerminal(e)}
                                filterOption={createFilter({ignoreAccents: false})}
                                captureMenuScroll={false}
                                classNamePrefix="custom-select"
                                components={{Option: CustomOption, MenuList: CustomMenuList}}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-3">
                    <div className="d-flex justify-content-between ">
                        <label>Txn Date From:</label>
                        <div>
                            {/*  <input
                                type="text"
                                className="form-control form-control-sm"
                                style={{width: "12.5vw"}}
                                defaultValue={moment(new Date()).format("MM/DD/YYYY HH:mm:ss")}
                                onChange={(e) =>
                                    setTxnDateFrom(moment(e.target.value).format("MM/DD/YYYY HH:mm:ss"))
                                }
                            />*/}

                            {  <DateRangePicker
                                initialSettings={{
                                    timePicker: true,
                                    singleDatePicker: true,
                                    //showDropdowns: true,
                                    startDate: moment().startOf('day').add(-1, 'day'),
                                    //endDate: moment().startOf('hour').add(32, 'hour').toDate(),
                                    locale: {
                                        format: 'MM/DD/YYYY hh:mm:ss',
                                    },
                                }}
                                onCallback={handletxnLookupStartDate}
                            >
                                <input type="text" className="form-control" />
                            </DateRangePicker>}

                        </div>
                    </div>
                </div>
                <div className="col col-md-3">
                    <div className="d-flex justify-content-between ">
                        <label>Txn Date To:</label>
                        <div>
                            {/* <input
                                type="datetime-local"
                                className="form-control form-control-sm"
                                style={{width: "12.5vw"}}
                                onChange={(e) =>
                                    setTxnDateTo(moment(e.target.value).format("MM/DD/YYYY HH:mm:ss"))
                                }
                            />*/}


                            <DateRangePicker
                                initialSettings={{
                                    timePicker: true,
                                    singleDatePicker: true,
                                    //showDropdowns: true,
                                    startDate:  moment().startOf('day'),
                                    //endDate: moment().startOf('hour').toDate(),
                                    locale: {
                                        format: 'MM/DD/YYYY hh:mm:ss',
                                    },
                                }}
                                onCallback={handletxnLookupEndDate}
                            >
                                <input type="text" className="form-control" />
                            </DateRangePicker>
                        </div>
                    </div>
                </div>

            </div>
            {/*  */}
            <div className="row mt-3">
                <div className="col col-md-3" style={{display: "none"}}>
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Time From:</label>
                        <div>
                            <input
                                type="time"
                                className="form-control form-control-sm"
                                style={{width: "12.5vw"}}
                                onChange={(e) =>
                                    setTxnTimeFrom(
                                        (e.target.value)
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-3" style={{display: "none"}}>
                    <div className="d-flex justify-content-between ">
                        <label>TraceID:</label>
                        <div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                style={{width: "12.5vw"}}
                                onChange={(e) =>
                                    setTraceID(
                                        (e.target.value)
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-3" style={{display: "none"}}>
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Bank TraceNo:</label>
                        <div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                style={{width: "12.5vw"}}
                                onChange={(e) =>
                                    setBankTraceNo(
                                        (e.target.value)
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-3" style={{display: "none"}}>
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Trace Due:</label>
                        <div>
                            <input
                                type="date"
                                className="form-control form-control-sm"
                                style={{width: "12.5vw"}}
                                onChange={(e) =>
                                    setTraceDue(
                                        (e.target.value)
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col col-md-3" style={{display: "none"}}>
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Settlement Date From:</label>
                        <div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                style={{width: "12.5vw"}}
                                onChange={(e) =>
                                    setSettDateFrom(
                                        (e.target.value)
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-3" style={{display: "none"}}>
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Settlement Date To:</label>
                        <div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                style={{width: "12.5vw"}}
                                onChange={(e) =>
                                    setSettDateTo(
                                        (e.target.value)
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-3" style={{display: "none"}}>
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Time To:</label>
                        <div>
                            <input
                                type="time"
                                className="form-control form-control-sm"
                                style={{width: "12.5vw"}}
                                onChange={(e) =>
                                    setTxnTimeTo(
                                        (e.target.value)
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-3">
                    <div className="d-flex justify-content-between">
                        <label>PAN:</label>
                        <div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                style={{width: "12.5vw"}}
                                onChange={(e) =>
                                    setPan(
                                        (e.target.value)
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Txn Type:</label>
                        <div>
                            <Select
                                options={traceInitiatorOptions}
                                value={selectedTraceInitiator}
                                onChange={(e) => setTraceInitiator(e)}
                                filterOption={createFilter({ignoreAccents: false})}
                                captureMenuScroll={false}
                                classNamePrefix="custom-select"
                                components={{Option: CustomOption, MenuList: CustomMenuList}}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col col-md-3" style={{display: "none"}}>
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Trace Status:</label>
                        <div>
                            <Select
                                options={traceStatusOptions}
                                value={selectedTraceStatus}
                                onChange={(e) => setTraceStatus(e)}
                                filterOption={createFilter({ignoreAccents: false})}
                                captureMenuScroll={false}
                                components={{Option: CustomOption, MenuList: CustomMenuList}}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-3" style={{display: "none"}}>
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Gateway:</label>
                        <div>
                            <Select
                                options={gatewayOptions}
                                value={selectedGateway}
                                onChange={(e) => setGateway(e)}
                                filterOption={createFilter({ignoreAccents: false})}
                                captureMenuScroll={false}
                                components={{Option: CustomOption, MenuList: CustomMenuList}}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-3" style={{display: "none"}}>
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Dispensed Status:</label>
                        <div>
                            <Select
                                options={dispensedStatusOptions}
                                value={selectedDispensedStatus}
                                onChange={(e) => setDispensedStatus(e)}
                                filterOption={createFilter({ignoreAccents: false})}
                                captureMenuScroll={false}
                                components={{Option: CustomOption, MenuList: CustomMenuList}}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-3" style={{display: "none"}}>
                    <div className="d-flex justify-content-between align-items-center">
                        <label>ISO:</label>
                        <div>
                            <Select
                                options={ISOOptions}
                                value={selectedISO}
                                onChange={(e) => setISO(e)}
                                filterOption={createFilter({ignoreAccents: false})}
                                captureMenuScroll={false}
                                components={{Option: CustomOption, MenuList: CustomMenuList}}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row d-flex justify-content-center mt-1 align-items-center">
                {totalRecords>0 ? ( <span
                    class="input-group-text"
                    role="button"
                    onClick={() => generateExcel()}
                >
                    Export to Excel</span>): (<span>&nbsp;</span>)}
                <span
                    class="input-group-text ml-4"
                    role="button"
                    onClick={() => handleGetReport()}
                >Search</span>
                <span class="input-group-text ml-4" role="button" onClick={handleReset}>
          Clear Search Options
        </span>
            </div>
            {/*  */}
            <div className="mt-3">
                {/*{isTableVisible && <Table columns={columns} data={data} />}*/}
                {isTableVisible && <DataTableExtensions
                    columns={datacolumns}
                    data={data}
                    print={false}
                    export={false}
                >

                    <DataTable
                        columns={datacolumns}
                        data={data}
                        noHeader
                        pagination
                        highlightOnHover
                        pointerOnHover
                        paginationServer
                        paginationTotalRows={totalRecords}
                        paginationPerPage={perPage}
                        paginationComponentOptions={{
                            noRowsPerPage: true
                        }}
                        onRowClicked={onRowClicked}
                        onChangePage={page => setCurrentPage(page)}
                        customStyles={tableStyles}
                    />
                </DataTableExtensions>}
            </div>
        </div>
    );
}

export default TransactionLookupDatatable;
